import * as React from 'react';
import { createRoot } from 'react-dom/client';
import reactDom from 'react-dom';
// import { BrowserTracing } from '@sentry/tracing';
import * as ReactRouter from 'react-router';
import { BrowserRouter as Router, Route, Routes, useNavigate, useLocation, Navigate, createBrowserRouter } from 'react-router';
import * as MabinsoCommons from '@mabinso-registry/module-commons';
import * as MabinsoUniversal from '@mabinso-registry/mabinso-universal';
import { ui, Document, Ajax } from '@mabinso-registry/module-commons';
import Login from './components/login/Login';
import App from './components/app/App';
import auth from './utils/Auth';
import Info from './components/info/Info';
import Globals from './utils/Globals';
// import Ajax from './utils/Ajax';
// import MyDocument from './components/document/Document';
import Detail from './components/report/components/detail/Detail';
import APIContextProvider from './ApiContextProvider';
import PrivateRoute from './PrivateRoute';

window['React'] = React as any;
window['ReactDOM'] = reactDom;
window['MabinsoCommons'] = MabinsoCommons;
window['MabinsoUniversal'] = MabinsoUniversal;
window['ReactRouter'] = ReactRouter;

const Logout = () => {
    const samlEnabled = Globals.saml;
    const token = auth.getToken();
    console.log('logout ------------------> ' + token);
    const isSaml = localStorage.getItem('isSaml');
    localStorage.removeItem('saml');
    localStorage.removeItem('isSaml');
    if (samlEnabled && isSaml === 'true') {
        auth.logout(() => {});
        const navTo = Globals.baseUrl + 'saml/doLogout?redirect=' + Globals.rootUrl + '&token=' + token;
        return <Navigate to={navTo} />;
    } else {
        console.log('logout ------------------> ' + token);
        Ajax.getJson('logout');
        auth.logout(() => {});
        return <Navigate to="/login" replace />;
    }
};

const InitRoute = ({ component: Component, ...rest }) => {
    const { pathname } = useLocation();
    if (auth.loggedIn() && pathname.search('login') !== -1) {
        return <Navigate to="/" />;
    }
    return <Component {...rest} />;
};

if (process.env.NODE_ENV === 'production' && Globals.serverConfig && (Globals.serverConfig as any).sentry) {
    const integrations = [];
    /* if (Globals.clientConfig.sentryTracing) {
        integrations.push(
            new BrowserTracing({
                tracingOrigins: [Globals.baseUrl],
            })
        );
    }*/
    /* Sentry.init({
        dsn: 'https://4764d0021a0e4bfebda3c9632a4c9a25@sentry.mabinso-server.de/2',
        integrations,
        release: process.env.REACT_APP_VERSION,
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
    });*/
}

const InfoDoc = (props) => {
    const navigate = useNavigate();
    return (
        <Document
            closeLink={() => {
                navigate('/index.reports');
            }}
            {...props}
        >
            <Info />
        </Document>
    );
};
const ReportDoc = (props) => {
    const navigate = useNavigate();
    return (
        <Document
            closeLink={() => {
                navigate('/index.reports');
            }}
            {...props}
        >
            <Detail {...props} />
        </Document>
    );
};
const SamlRoute = () => {
    const navTo = Globals.baseUrl + 'saml/login?redirect=' + Globals.rootUrl + '/login';
    //return <Navigate to={navTo} replace />;
    window.location.href = navTo;
    return null;
};

const container = document.getElementById('root');
const root = createRoot(container);

const ThemeProvider = ui.ThemeProvider as any;
const CssBaseline = ui.CssBaseline as any;
const StyledEngineProvider = ui.StyledEngineProvider as any;

root.render(
    <ThemeProvider theme={ui.theme}>
        <CssBaseline />
        <StyledEngineProvider injectFirst>
            <APIContextProvider>
                <Router>
                    <Routes>
                        <Route path="/saml/login" element={<SamlRoute />} />
                        <Route path="/login/:token?" element={<InitRoute component={Login} />} />
                        <Route path="/logout" element={<Logout />} />
                        <Route path="/license-expired" element={<InitRoute component={InfoDoc} />} />
                        <Route path="/info" element={<InitRoute component={InfoDoc} />} />
                        <Route path="/report/:reportSavedId/:format/:token" element={<InitRoute component={ReportDoc} />} />
                        <Route path="/*" element={<PrivateRoute component={App} />} />
                    </Routes>
                </Router>
            </APIContextProvider>
        </StyledEngineProvider>
    </ThemeProvider>
);
